import appendData, { appendMultiStepData } from "common/utility";
import {
  del,
  get,
  getWithExportFile,
  post,
  postAsForm,
  put,
} from "helpers/api_helper";

export const adminLogin = (data) => {
  return post("/admin/login", data);
};

export const getAllProperties = (
  pageNumber,
  pageSize,
  filter = "",
  fromDate,
  toDate,
  isBlocked = "",
  kycStatus = "",
  exportRequest = "false",
  analytics = false,
  dateRangeType = "",
  soldPriceRange = "",
  daysOnMarket = "",
  sortBy = "",
  avgPriceRange = "",
  commissionRange = "",
  minSqft = "",
  maxSqft = "",
  minPricePerSqft = "",
  maxPriceSqft = "",
  brokerId = "",
  propertyType = ""
) => {
  let url = `/admin/listings?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${encodeURIComponent(filter)}&fromDate=${fromDate}&toDate=${toDate}&isBlocked=${isBlocked}&kycStatus=${kycStatus}&exportRequest=${exportRequest}`;
  
  if (analytics) {
    url += `&analytics=true`;
    if (dateRangeType) url += `&dateRangeType=${dateRangeType}`;
    if (soldPriceRange) url += `&soldPriceRange=${soldPriceRange}`;
    if (daysOnMarket) url += `&daysOnMarket=${daysOnMarket}`;
    if (sortBy) url += `&sortBy=${sortBy}`;
    if (avgPriceRange) url += `&avgPriceRange=${avgPriceRange}`;
    if (commissionRange) url += `&buyerAgentCommission=${commissionRange}`;
    if (minSqft) url += `&minSqft=${minSqft}`;
    if (maxSqft) url += `&maxSqft=${maxSqft}`;
    if (minPricePerSqft) url += `&minPricePerSqft=${minPricePerSqft}`;
    if (maxPriceSqft) url += `&maxPriceSqft=${maxPriceSqft}`;
    if (propertyType) url += `&propertyType=${propertyType}`;
  }
  
  // Add broker ID for role-based filtering
  if (brokerId) {
    url += `&id=${brokerId}`;
  }
  
  return getWithExportFile(url);
};

export const getAllBrokers = (
  pageNumber,
  pageSize,
  filter = "",
 fromDate,
  toDate,
  isBlocked = "",
  kycStatus = "",
  exportRequest = "false"
) => {
  return getWithExportFile(
    `/admin/brokerages?pageNumber=${pageNumber}&pageLimit=${pageSize}&search=${encodeURIComponent(filter)}&startDate=${fromDate}&endDate=${toDate}&isBlocked=${isBlocked}&kycStatus=${kycStatus}&exportRequest=${exportRequest}`
  );
};
export const getBrokerAgents = (
  agentId,
  pageNumber,
  pageSize,
  filter = "",
  country = "",
  city = "",
  rating = "",
  fromDate,
  toDate
) => {
  return getWithExportFile(
    `/admin/brokerages?pageNumber=${pageNumber}&pageLimit=${pageSize}&search=${filter}&country=${country}&city=${city}&starRating=${rating}&startDate=${fromDate}&endDate=${toDate}`
  );
};
export const getAllUsers = (
  pageNumber,
  pageSize,
  filter = "",
  fromDate,
  toDate,
  sortBy = "",
  exportRequest = "false"
) => {
  return getWithExportFile(
    `/admin/users?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${encodeURIComponent(filter)}&fromDate=${fromDate}&toDate=${toDate}&transferStatus=${sortBy}&exportRequest=${exportRequest}`
  );
};

export const getAgentsProperties =(
  userId,
  pageNumber,
  pageSize,
  filter="",
  fromDate,
  toDate,
  sortBy="",
  exportRequest ="false"
)=>{
  return getWithExportFile(
    `/admin/agents/${userId}/properties?pageNumber=${pageNumber}$pageSize=${pageSize}&filter=${encodeURIComponent(filter)}&fromDate=${fromDate}&toDate=${toDate}&transferStatus=${sortBy}&exportRequest=${exportRequest}`
  )
}


export const getAllPropertyLogs = (
  id,
  pageNumber,
  pageSize,
  filter = "",
  fromDate,
  toDate
) => {
  return getWithExportFile(
    `/admin/getAllLogsData?propertyId=${id}&pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${encodeURIComponent(filter)}&fromDate=${fromDate}&toDate=${toDate}`
  );
};

export const getPropertyDetailsById = (id) => {
  return get(`/admin/property/${id}`);
};

export const saveOrUpdateProprty = (data) => {
  // const formData = appendData(data);
  return postAsForm("/admin/savePropertyDetails", data);
};
export const deleteProperty = (data) => {
  return del("admin/deleteProperty", null, data);
};

export const deleteActiveProperty = (data) => {
  return post("/admin/softDeleteProperty", data);
};

export const getAllRooms = (id, pageNumber, pageSize, filter = "") => {
  return getWithExportFile(
    `/admin/getPropertyRoomDetails?propertyId=${id}&pageNumber=${pageNumber}&pageLimit=${pageSize}&search=${filter}`
  );
};
export const getBookingEnginePropertyDetails = (
  id,
  fromDate,
  toDate,
  adults,
  children
) => {
  return getWithExportFile(
    `/property/room-and-price-details?propertyId=${id}&fromDates=${fromDate}&toDates=${toDate}&adults=${adults}&children=${children}`
  );
};
export const getAllRoomsById = (id, pageNumber, pageSize, filter = "") => {
  return getWithExportFile(`/admin/getRoomDetailsById?roomId=${id}`);
};
export const getWeekendAndPublicHolidayDetails = (
  id,
  type,
  pageNumber,
  pageSize
) => {
  return getWithExportFile(
    `/admin/getPriceAdjustmentDetails?roomId=${id}&type=${type}&pageNumber=${pageNumber}&pageLimit=${pageSize}`
  );
};
export const getRoomPricingAndAvailabiltyDetails = (
  id,
  pageNumber,
  pageSize
) => {
  return getWithExportFile(
    `/admin/getRoomPricingAndAvailabiltyDetails?roomId=${id}&pageNumber=${pageNumber}&pageLimit=${pageSize}`
  );
};
export const getAllWeekendAndRoomData = (
  id,
  pageNumber,
  pageSize,
  filter = ""
) => {
  return getWithExportFile(`/admin/getRoomDetailsById?roomId=${id}`);
};
export const saveOrUpdateRoom = (data) => {
  // const formData = appendMultiStepData(data);
  // return postAsForm("/admin/saveRoom", formData);
  return postAsForm("/admin/saveRoom", data);
};
export const saveRoomPricingAndAvailability = (data) => {
  return post("/admin/saveRoomPricingAndAvailability", data);
};
export const saveCancellationDetails = (data) => {
  return post("/admin/saveCancellationDetails", data);
};
export const saveWeekendAndPublicHolidayDetails = (data) => {
  return post("/admin/savePriceAdjustment", data);
};
export const deleteRoom = (data) => {
  return del("admin/deleteRoom", null, data);
};

export const deleteHoliday = (data) => {
  return del("admin/deleteWeekendAndPublicHolidayDetail", data);
};

export const deleteRoomAvailibility = (data) => {
  return del("admin/deleteRoomAvailabilityAndPricingDetail", data);
};

export const softDeleteRoomAvailibility = (data) => {
  return post("/admin/softDeleteRoomPricingAndAvailability", data);
};

export const softDeleteHoliday = (data) => {
  return post("/admin/softDeletePriceAdjustment", data);
};

export const deleteActiveRoom = (data) => {
  return post("/admin/softDeleteRoom", data);
};



export const saveUser=(data)=>{
  return post("/admin/addUserManually", data);
}

export const getMembershipUsers = (
  pageNumber,
  pageSize,
  filter = "",
  fromDate,
  toDate,
  sortBy = "",
  exportRequest = "false"
) => {
  return getWithExportFile(
    `/admin/getMemberships?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${filter}&fromDate=${fromDate}&toDate=${toDate}&transferStatus=${sortBy}&exportRequest=${exportRequest}`
  );
};

export const getSubadmins = (
  pageNumber,
  pageSize,
  filter = "",
  fromDate,
  toDate,
  sortBy = "",
  exportRequest = "false"
) => {
  return getWithExportFile(
    `/admin/getAllAdmins?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${filter}&fromDate=${fromDate}&toDate=${toDate}&transferStatus=${sortBy}&exportRequest=${exportRequest}`
  );
};

export const getAllMembershipPlans = (filter = "") => {
  return getWithExportFile(`/admin/getMembershipPlans?search=${filter}`);
};
export const deleteSubAdmin = (data) => {
  return del("/admin/deleteAdmin",null, data);
};

export const saveUpdateMembershipPlan = (data) => {
  const formData = appendMultiStepData(data);
  return postAsForm("/admin/saveMembershipPlan", formData);
};

export const getRevenueDetail = (id) => {
  return get(`/revenue/getRevenueData?id=${id}`);
};

export const saveUpdateProvider = (data) => {
  return post("/provider/createOrUpdateProvider", data);
};

export const saveUpdateSubAdmin= (data) => {
  return post("/admin/saveAdmin", data);
};
export const getProviderData = (filter = "") => {
  return getWithExportFile(`/provider/getAllProviderData?filter=${encodeURIComponent(filter)}`);
};

export const activateDeactivateProvider = (data) => {
  return post("/provider/softDeleteProviderDetails", data);
};

export const saveUpdateRevenueRuleSet = (data) => {
  return post("/revenue/saveRevenue", data);
};
export const getRevenueData = (pageNumber, pageSize, filter = "") => {
  return getWithExportFile(
    `/revenue/getAllRevenueData?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
};

export const getAllBookingTransactions = (
  pageNumber,
  pageSize,
  filter = "",
  fromDate,
  toDate
) => {
  return getWithExportFile(
    `/admin/getAllBookengTransaction?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${encodeURIComponent(filter)}&fromDate=${fromDate}&toDate=${toDate}`
  );
};

export const checkProopertyAvailability = (
  destination,
  fromDate,
  toDate,
  adults,
  rooms,
  children
) => {
  return getWithExportFile(
    `/property/check-room-availability?destination=${destination}&fromDates=${fromDate}&toDates=${toDate}&adults=${adults}&rooms=${rooms}&children=${children}`
  );
};

export const getPropertiesData = (search) => {
  return get(
    `/property/get-property-name?pageNumber=1&pageLimit=5&searchName=${search}`
  );
};

export const getAllQueries = (
  pageNumber,
  pageSize,
  filter = "",
  fromDate,
  toDate,
  exportRequest = "false"
) => {
  return getWithExportFile(
    `/admin/getAllContactUsData?pageNumber=${pageNumber}&pageLimit=${pageSize}&search=${filter}&startDate=${fromDate}&endDate=${toDate}&exportRequest=${exportRequest}`
  );
};
export const selectRooms = (data) => {
  return post("/admin/roomSelectByAdmin", data);
};
export const gettingTotalPrice = (data) => {
  return post("/property/lastBookingAmount", data);
};
export const bookRooms = (data) => {
  return post("/admin/bookRoomByAdmin", data);
};
export const saveOptions = (data) => {
  return post("/admin/saveOptionType", data);
};
export const getOptions = () => {
  return get("/admin/getOptionTypes");
};
export const getAmenities = (filter) => {
  return get(`/admin/GetAminities?filter=${encodeURIComponent(filter)}`);
};
export const saveOrUpdateAmenity = (data) => {
  const formData = appendData(data);
  return postAsForm("/admin/createAminities", formData);
};
export const deleteAmenity = (data) => {
  return del("admin/deleteAminitiesDetail", data);
};
export const deleteMembershipPlan = (data) => {
  return del("admin/deleteMembershipPlan", null, data);
};
export const changeQueryStatus = (data) => {
  return post("/admin/contactUsStatusChange", data);
};

export const getDashboardStats = () => {
  return get("investors/getDashBoard");
};
export const getPropertyCities = () => {
  return get("/admin/getAllCities");
};

export const getFaqDetail = () => {
  return get("/cms/home/getFaq");
};
export const addNewFaq = (data) => {
  return post("/cms/home/faq2", data);
};

export const updateFaq = (data) => {
  return put("cms/home/updateFaq", data);
};
export const deleteFaqData = (data) => {
  return del("cms/home/deleteFaq", data);
};

export const deleteRevenueDetail = (id) => {
  return del(`/revenue/deleteRevenueDetail?id=${id}`);
};

// Point Engine API Services
export const createOrUpdatePointEngineItem = (data) => {
  return post("/point/create", data);
};

export const getAllPointEngineItems = () => {
  return get("/point/getAllPointEngineItems");
};

export const getPointEngineItemById = (id) => {
  return get(`/point/getPointEngineItemById?id=${id}`);
};

export const deletePointEngineItem = (id) => {
  return del("/api/point/deletePointEngineItem", id);
};

// Promo Engine API Services
export const createOrUpdatePromo = (data) => {
  return post("/promo/create", data);
};
export const getAllPromos = (pageNumber, pageSize, filter = "",status = "",promoType='') => {
  return getWithExportFile(
    `/promo/getAllPromos?page=${pageNumber}&limit=${pageSize}&search=${filter}&status=${status}&promoType=${promoType}`
  );
};

export const getPromoById = (id) => get(`/promo/getPromoById?id=${id}`);

export const deletePromo = (data) => {
  return del("promo/deletePromo", data);
};

export const getPromoReport = (data) => {
  return post("/promo/report", data);
};

export const getPromoByCode = (promoCode) => {
  return get(`/api/promo/getPromoByCode?promoCode=${promoCode}`);
};

export const togglePromoStatus = (data) => {
  return put("/promo/toggleStatus", data);
};

export const getActivePromos = () => {
  return get("/promo/getActivePromos");
};

export const validatePromo = (data) => {
  return post("/promo/validatePromo", data);
};

export const getAmountAfterPromoAndPoint = (data) => {
  return post("/promo/getAmountAfterPromoAndPoint", data);
};

export const revertDiscount = (data) => {
  return post("/promo/revertDiscount", data);
};

//Booking Engine
export const getAvailableRooms = (data) => post('/booking-engine/get-rooms-availability', data);

export const getMembershipByUserId = (userId) => {
  return get(`/admin/getMembershipByUserId?userId=${userId}`);
};

export const getMemberships = (
  pageNumber,
  pageSize,
  search = "",
  sort = "desc",
  isActive = "",
  fromDate = "",
  toDate = ""
) => {
  return get(
    `/admin/getMemberships?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}&sort=${sort}&isActive=${isActive}&fromDate=${fromDate}&toDate=${toDate}`
  );
};

// Subscription Packages API Services
export const getAllSubscriptionPackages = () => {
  return get("/subscription-packages/admin");
};

export const createSubscriptionPackage = (data) => {
  return post("/subscription-packages/admin", data);
};

export const updateSubscriptionPackage = (packageId, data) => {
  return put(`/subscription-packages/admin/${packageId}`, data);
};

export const deleteSubscriptionPackage = (packageId) => {
  return del(`/subscription-packages/admin/${packageId}`, null);
};

export const createStripeProduct = (packageId) => {
  return post("/stripe/admin/create-product", { packageId });
};

export const getSubscriptionRequired = () => {
  return get("/subscription-packages/admin/subscription-required");
};

export const toggleSubscriptionRequired = (subscriptionRequired) => {
  return put("/subscription-packages/admin/toggle-subscription-required", { subscriptionRequired });
};

// Payment Issues API Services
export const getBrokersWithPaymentIssues = (
  pageNumber = 1,
  pageSize = 20,
  status = ""
) => {
  let url = `/admin/brokers/payment-issues?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  if (status) {
    url += `&status=${encodeURIComponent(status)}`;
  }
  return get(url);
};

// Property Features API Services
export const getAllPropertyFeatures = (category = "", isActive = "", search = "", pageNumber = 1, pageSize = 10) => {
  let url = `/admin/property-features`;
  const params = [];
  if (category) params.push(`category=${encodeURIComponent(category)}`);
  if (isActive !== "") params.push(`isActive=${isActive}`);
  if (search) params.push(`search=${encodeURIComponent(search)}`);
  params.push(`pageNumber=${pageNumber}`);
  params.push(`pageSize=${pageSize}`);
  if (params.length > 0) url += `?${params.join("&")}`;
  return get(url);
};

export const getPropertyFeaturesGrouped = (isActive = "", search = "") => {
  let url = `/admin/property-features/grouped`;
  const params = [];
  if (isActive !== "") params.push(`isActive=${isActive}`);
  if (search) params.push(`search=${encodeURIComponent(search)}`);
  if (params.length > 0) url += `?${params.join("&")}`;
  return get(url);
};

export const getPropertyFeaturesByCategory = (category, activeOnly = false) => {
  let url = `/admin/property-features/category/${category}`;
  if (activeOnly) url += `?activeOnly=true`;
  return get(url);
};

export const getPropertyFeatureById = (featureId) => {
  return get(`/admin/property-features/${featureId}`);
};

export const getPropertyFeatureCategories = () => {
  return get("/admin/property-features/categories/list");
};

export const getPropertyFeatureStats = () => {
  return get("/admin/property-features/stats/counts");
};

export const createPropertyFeature = (data) => {
  return post("/admin/property-features", data);
};

export const updatePropertyFeature = (featureId, data) => {
  return put(`/admin/property-features/${featureId}`, data);
};

export const bulkCreatePropertyFeatures = (data) => {
  return post("/admin/property-features/bulk", data);
};

export const softDeletePropertyFeature = (featureId) => {
  return del(`/admin/property-features/${featureId}`, null);
};

export const hardDeletePropertyFeature = (featureId) => {
  return del(`/admin/property-features/${featureId}/permanent`, null);
};

// User-scoped helpers
